module.exports = __webpack_public_path__ + "static/grecianIsleRules-placement-min.c78ce4ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/instructional/grecianIsleRules-placement-min.jpg
// module id = 147
// module chunks = 66570062548345 213534597649335